import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import AgreementsForm from './AgreementsForm';
import { assign } from '../../shared/Assign';
import * as actions from './AgreementsActions';
import { ICreateAgreement, IProductCompensation, IEditAgreementViewModel } from './Entities';
import notify from '../../shared/feedback/notifications';
import { handleError } from '../../shared/ErrorCatching';

class AgreementsModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            creating: false,
            productCompensation: {},
            addedProductCompensations: [],
            chosenProductType: '',
            errors: {},
            agreement: {},
            deletedProductCompensations: []
        };

        this.onChange = this.onChange.bind(this);
        this.addProductCompensation = this.addProductCompensation.bind(this);
        this.save = this.save.bind(this);
        this.onTextpropChange = this.onTextpropChange.bind(this);
        this.isFormValid = this.isFormValid.bind(this);
        this.onProductTypeChange = this.onProductTypeChange.bind(this);
        this.deleteProductCompensation = this.deleteProductCompensation.bind(this);
        this.saveButtonDisabled = this.saveButtonDisabled.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.editId > 0) {
            this.setState({ agreement: assign({}, nextProps.agreement) });
        } else {
            this.setState({ agreement: assign({}, {}) });
        }
    }

    componentDidMount() {
        if (this.props.editId > 0) {
            this.props.actions
                .editAgreement(this.props.editId)
                .catch((error: any) => handleError(error));
        } else {
            this.props.actions.newAgreement().catch((error: any) => handleError(error));
        }
    }

    onTextpropChange(e: any, propertyName: string) {
        let agreement = this.state.agreement;
        agreement[propertyName] = e.target.value;
        this.setState({ agreement: assign({}, agreement) });
    }

    onChange(e: any) {
        let productCompensation = this.state.productCompensation;
        productCompensation[e.target.name] = e.target.value;

        if (e.target.name === 'productGroup') {
            productCompensation['productId'] = '';
        }

        this.setState({ productCompensation: assign({}, productCompensation) });
    }

    onProductTypeChange(e: any) {
        this.setState({ chosenProductType: e.target.value });
    }

    addProductCompensation() {
        let agreement = assign({}, this.state.agreement);
        let productCompensation = assign({}, this.state.productCompensation);
        let productCompensations = agreement['productCompensations'];

        if (!productCompensations) {
            productCompensations = [];
        }

        productCompensations.push(productCompensation);
        agreement['productCompensations'] = productCompensations;
        this.setState({
            productCompensation: {},
            chosenProductType: '',
            agreement: agreement
        });
    }

    deleteProductCompensation(id: number, product: number) {
        let agreement = this.state.agreement;
        if (id) {
            let deletedProductCompensations = this.state.agreement.deletedProductCompensations;

            if (!deletedProductCompensations) {
                deletedProductCompensations = [];
            }

            deletedProductCompensations.push(id);
            agreement['deletedProductCompensations'] = deletedProductCompensations;
        }

        let productCompensations = this.state.agreement.productCompensations;
        let filteredProductCompensations = productCompensations.filter(
            (pp: IProductCompensation) => {
                return pp.productId.toString() !== product.toString();
            }
        );

        agreement.productCompensations = filteredProductCompensations;

        this.setState({ agreement: assign({}, agreement) });
    }

    save() {
        this.setState({ creating: true });

        if (this.state.agreement.id) {
            this.props.actions
                .updateAgreement(this.state.agreement)
                .then((result: any) => {
                    notify.success(Translate('agreements/notification/agreement-updated'));
                    this.setState({
                        creating: false,
                        addedProductCompensations: assign([], [])
                    });
                    this.props.toggleModal();
                })
                .catch((error: any) =>
                    handleError(error, (errors: any): void => {
                        this.setState({ errors: errors, creating: false });
                    })
                );
        } else {
            this.props.actions
                .create(this.state.agreement)
                .then((result: any) => {
                    notify.success(Translate('agreements/notification/agreement-added'));
                    this.setState({
                        creating: false,
                        addedProductCompensations: assign([], [])
                    });
                    this.props.toggleModal();
                })
                .catch((error: any) =>
                    handleError(error, (errors: any): void => {
                        this.setState({ errors: errors, creating: false });
                    })
                );
        }
    }

    isFormValid(): boolean {
        let name = this.state.agreement.name;
        let productCompensation = this.state.productCompensation;
        let productType = this.state.chosenProductType;
        let formValid =
            name &&
            name !== '' &&
            productCompensation &&
            productType &&
            productType !== '' &&
            productCompensation.productId &&
            productCompensation.productId !== '' &&
            productCompensation.compensation &&
            productCompensation.compensation !== '';

        if (!formValid) {
            return true;
        }

        let addedProductCompensations = this.state.agreement.productCompensations;

        let exists: any = [];
        if (addedProductCompensations) {
            exists = addedProductCompensations.filter((pp: IProductCompensation) => {
                return pp.productId.toString() === productCompensation.productId.toString();
            });
        }

        if (exists.length === 0) {
            return false;
        }

        return true;
    }

    saveButtonDisabled(): boolean {
        if (this.state.creating) {
            return true;
        } else if (!this.state.agreement.productCompensations) {
            return true;
        } else {
            return this.state.agreement.productCompensations.length === 0;
        }
    }

    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.props.toggleModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.agreement.id
                            ? Translate('agreements/modal/title/edit-agreement')
                            : Translate('agreements/modal/title/create-agreement')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AgreementsForm
                        agreement={this.state.agreement}
                        onChange={this.onChange}
                        chosenProductType={this.state.chosenProductType}
                        productCompensation={this.state.productCompensation}
                        productTypes={this.props.productTypes}
                        addProductCompensation={this.addProductCompensation}
                        onNameChange={(e) => this.onTextpropChange(e, 'name')}
                        onDescriptionChange={(e) => this.onTextpropChange(e, 'description')}
                        onProductTypeChange={this.onProductTypeChange}
                        isFormValid={this.isFormValid}
                        errors={this.state.errors}
                        delete={this.deleteProductCompensation}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.toggleModal}>
                        {Translate('agreements/modal/footer-button/close')}
                    </Button>
                    <Button
                        bsStyle="primary"
                        disabled={this.saveButtonDisabled()}
                        onClick={this.save}
                    >
                        {this.state.creating
                            ? Translate('agreements/modal/footer-button/saving')
                            : Translate('agreements/modal/footer-button/save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        productTypes: state.agreements.modal.productTypes,
        agreement: state.agreements.edit.agreement
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            newAgreement: () => dispatch(actions.newAgreement()),
            create: (agreement: ICreateAgreement) => dispatch(actions.createAgreement(agreement)),
            editAgreement: (id: number) => dispatch(actions.editAgreement(id)),
            updateAgreement: (agreement: IEditAgreementViewModel) =>
                dispatch(actions.updateAgreement(agreement))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgreementsModal);
